(function() {

  angular
    .module('meanApp')
    .service('alert', alert);

  alert.$inject = ['$rootScope'];
  function alert ($rootScope) {
    //initialize the functions and arrays
    console.log('rootscope - init alert');
    var pendingList= [];
    $rootScope.alerts=[];
    $rootScope.closeAlert = function(index) {
        console.log('rootscope - close alert');
        $rootScope.alerts.splice(index, 1);
        pendingList.shift();//remove first item
        //check if there is some alert to push left in the pendingList
        var firstItem = pendingList[0];
        if (firstItem) {
            $rootScope.alerts.push(firstItem);
        }
    };

    this.push = function (type, msg) {
        console.log('rootscope - push alert');
        var alertObject = { 
            type: type, 
            msg: msg 
        };

        //if pending list empty push the alert directly
        
        if(pendingList.length === 0) {
            $rootScope.alerts.push(alertObject);
        }
        pendingList.push(alertObject);
    }

    return this;
  }

})();